// Définition des packs d'abonnement Kreylik
// vehicleLimit / userLimit = -1 signifie illimité
export const PACK_CONFIG = {
  Start: {
    label: 'Kreylik Start',
    color: 'teal',
    vehicleLimit: 10,
    userLimit: 1,
    features: {
      dashboard:    false, // pas de dashboard pour Start
      vehicles:     true,
      clients:      true,
      reservations: true,
      contrats:     true,
      factures:     true,
      cautions:     true,
      maintenance:   false, // assurances, vidanges, visites-techniques
      financement:  false, // crédit bancaire et traites
      settings:     true,
      signature:    false, // pas de signature électronique
      multiUsers:   false,
      ocr:          false, // pas d'OCR
      createdBy:    false, // pas de traçabilité créé/modifié par
    },
  },
  Pro: {
    label: 'Kreylik Pro',
    color: 'blue',
    vehicleLimit: 30,
    userLimit: 3,
    features: {
      dashboard:    true,
      vehicles:     true,
      clients:      true,
      reservations: true,
      contrats:     true,
      factures:     true,
      cautions:     true,
      maintenance:  true,
      financement:  true,
      settings:     true,
      signature:    true,
      multiUsers:   true,
      ocr:          false, // pas d'OCR avancé
      createdBy:    true,  // traçabilité créé/modifié par
    },
  },
  ProPlus: {
    label: 'Kreylik Pro+',
    color: 'purple',
    vehicleLimit: -1,
    userLimit: -1,
    features: {
      dashboard:    true,
      vehicles:     true,
      clients:      true,
      reservations: true,
      contrats:     true,
      factures:     true,
      cautions:     true,
      maintenance:  true,
      financement:  true,
      settings:     true,
      signature:    true,
      multiUsers:   true,
      ocr:          true, // OCR avancé inclus
      createdBy:    true, // traçabilité créé/modifié par
    },
  },
};

export const PACK_LABELS = {
  Start:   'Kreylik Start',
  Pro:     'Kreylik Pro',
  ProPlus: 'Kreylik Pro+',
};

export const PACK_BADGE_COLORS = {
  Start:   'bg-teal-100 text-teal-700 border-teal-200',
  Pro:     'bg-blue-100 text-blue-700 border-blue-200',
  ProPlus: 'bg-purple-100 text-purple-700 border-purple-200',
};
